import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
  location: string;
  product?: string;
}
const TestimonialCard = ({
  quote,
  author,
  location,
  product
}: TestimonialProps) => <motion.div whileHover={{
  y: -5
}} className="bg-dark-800 p-6 rounded-2xl border border-primary/20 shadow-lg" data-id="element-255">
    <div className="flex mb-4" data-id="element-256">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-257" />)}
    </div>
    <p className="text-cream/90 italic mb-4 text-lg" data-id="element-258">"{quote}"</p>
    <div data-id="element-259">
      <p className="font-bold text-cream" data-id="element-260">{author}</p>
      <p className="text-sm text-primary" data-id="element-261">{location}</p>
      {product && <p className="text-xs text-cream/50 mt-1" data-id="element-262">{product}</p>}
    </div>
  </motion.div>;
export function TestimonialsFirstSet() {
  const testimonials = [{
    quote: 'En 3 días mi hijo dejó de llorar cuando le sacaba el celular. No lo puedo creer.',
    author: 'Valeria M.',
    location: 'Buenos Aires'
  }, {
    quote: 'El Tomo de experimentos fue un hit total. Ahora me pide hacer ciencia en vez de ver YouTube.',
    author: 'Carla P.',
    location: 'Rosario'
  }, {
    quote: 'El Kit Anti-Rabietas me salvó la vida. Ahora sé exactamente qué decir cuando explota.',
    author: 'Martín G.',
    location: 'Córdoba'
  }];
  return <section className="bg-dark-900 py-16 px-4" data-id="element-263">
      <div className="max-w-6xl mx-auto" data-id="element-264">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-265">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-266" />)}
        </div>
      </div>
    </section>;
}
export function TestimonialsSecondSet() {
  const testimonials = [{
    quote: 'Mi hijo tiene TDAH y pensé que era imposible. El protocolo de transición nos cambió la dinámica familiar completa. Ya no peleamos más por el celular.',
    author: 'Cecilia R.',
    location: 'Mendoza',
    product: 'MegaPack + Acompañamiento'
  }, {
    quote: 'Los experimentos del Tomo 2 son adictivos. Mi hija de 8 años literalmente me pide hacer ciencia los sábados. Antes era impensable sacarla de YouTube.',
    author: 'Roberto M.',
    location: 'Buenos Aires',
    product: 'MegaPack'
  }, {
    quote: 'Mi hijo de 4 años pedía el celu apenas se despertaba. Con el planificador visual del Tomo 6, ahora sabe qué viene después y no lo pide más.',
    author: 'Sofía C.',
    location: 'La Plata',
    product: 'MegaPack'
  }, {
    quote: 'Las frases del Kit Anti-Rabietas me salvaron. Antes no sabía qué decir cuando explotaba. Ahora lo bajo en minutos.',
    author: 'Pablo A.',
    location: 'Neuquén',
    product: 'MegaPack'
  }];
  return <section className="bg-dark-800 py-16 px-4" data-id="element-267">
      <div className="max-w-6xl mx-auto" data-id="element-268">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-cream mb-12" data-id="element-269">
          ❤️ MÁS FAMILIAS QUE YA LO TIENEN
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-270">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-271" />)}
        </div>
      </div>
    </section>;
}